import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { TransferProcessApiPort } from './ports/transfer-process-api.port';
import { AdessoTransferProcessApiAdapter } from './adapters/adesso-transfer-process-api.adapter';

/**
 * Provides TransferProcessApiPort backed by the adesso-connector-api adapter.
 */
export function provideTransferProcessApi(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: TransferProcessApiPort, useClass: AdessoTransferProcessApiAdapter }
  ]);
}
